import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from '@tanstack/react-query';
import { clientApi } from '../../configuration';
interface UsePathsInBulkParams {
  pathIds: number[];
}
const usePathsInBulk = t0 => {
  const $ = _c(13);
  const {
    pathIds
  } = t0;
  let t1;
  if ($[0] !== pathIds) {
    t1 = ["pathsInBulk", pathIds];
    $[0] = pathIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pathIds) {
    t2 = async t3 => {
      const {
        pageParam
      } = t3;
      const {
        body: entities,
        pagination: responsePagination
      } = await clientApi.getOCClient().helpers.learningContent.paths.find({
        ids: pathIds.join(","),
        start: pageParam - 19,
        end: pageParam
      });
      const totalEntities = responsePagination ? responsePagination.totalElements : entities?.length;
      return {
        entities,
        totalEntities,
        rangeEnd: pageParam
      };
    };
    $[2] = pathIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t1,
      initialPageParam: 19,
      queryFn: t2,
      retry: 1,
      refetchOnWindowFocus: false,
      getNextPageParam: _temp
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const pathRequest = useInfiniteQuery(t3);
  if (pathRequest.hasNextPage && !pathRequest.isFetchingNextPage) {
    pathRequest.fetchNextPage();
  }
  let data;
  let queryResult;
  if ($[7] !== pathRequest) {
    ({
      data,
      ...queryResult
    } = pathRequest);
    $[7] = pathRequest;
    $[8] = data;
    $[9] = queryResult;
  } else {
    data = $[8];
    queryResult = $[9];
  }
  const t4 = data?.pages;
  let t5;
  if ($[10] !== queryResult || $[11] !== t4) {
    t5 = {
      ...queryResult,
      data: t4
    };
    $[10] = queryResult;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default usePathsInBulk;
function _temp(t0) {
  const {
    rangeEnd,
    totalEntities: totalEntities_0
  } = t0;
  return rangeEnd + 1 >= totalEntities_0 ? undefined : rangeEnd + 20;
}